<template>
    <div>
        <breadcrumb :routerList="[{to:'/yuce/wxhuizong',title:'外销列表'},{title:'外销预测重新提报'}]"/>
        <div class="h-content">
            <div class="h-row">
                <div class="h-rowIn iconss" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            stripe
                            border
                            max-height="500"
                            style="width: 100%">
                        <el-table-column type="selection" width="40" align="center"></el-table-column>
                        <el-table-column
                                prop="id"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="预测编码">
                        </el-table-column>
                        <el-table-column
                                prop="country"
                                width="90"
                                :show-overflow-tooltip="true"
                                label="国家名称">
                            <template slot-scope="scope">
                                <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proModel"
                                width="140"
                                :show-overflow-tooltip="true"
                                label="型号">
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="产品编码">
                        </el-table-column>
                        <el-table-column
                                prop="protype"
                                width="90"
                                label="型号属性"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="factory"
                                width="90"
                                label="产地"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                width="60"
                                :show-overflow-tooltip="true"
                                label="数量">
                        </el-table-column>
                        <el-table-column
                                prop="useNumber"
                                :show-overflow-tooltip="true"
                                width="90"
                                label="可用数量">
                        </el-table-column>
                        <el-table-column
                                prop="forecastStatus"
                                :show-overflow-tooltip="true"
                                width="90"
                                label="预测状态">
                            <template slot-scope="scope">
                                <dictname category="yuce_zhuangt"  :v="scope.row.forecastStatus"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="warehouse"
                                width="80"
                                :show-overflow-tooltip="true"
                                label="库龄">
                        </el-table-column>
                        <!--<el-table-column-->
                        <!--prop="stockStatus"-->
                        <!--width="90"-->
                        <!--label="库存状态">-->
                        <!--<template slot-scope="scope">-->
                        <!--<dictname category="kucun_status"  :v="scope.row.stockStatus"/>-->
                        <!--</template>-->
                        <!--</el-table-column>-->
                        <el-table-column
                                prop="isSpecific"
                                width="110"
                                :show-overflow-tooltip="true"
                                label="常规或改制">
                            <template slot-scope="scope">
                                <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="specificReform"
                                :show-overflow-tooltip="true"
                                min-width="180"
                                label="改制要求">
                            <template slot-scope="scope">
                                <div style="text-align: left;">{{scope.row.specificReform}}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--<div class="h-tableAdd" @click="add">
                        <a>新增一行</a>
                    </div>-->
                </div>
                <wxxiangqing-update ref="mychild1" :order-number="orderNumber"></wxxiangqing-update>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="renovate">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="updateOpen(tableData[0])">修改</el-button>
            </div>
            <div>
                <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2">
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>产品选择</h1>
                            </div>
                        </div>
                    </div>
                    <div class="h-formLine">
                        <el-form ref="form" :model="f" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                            <el-form-item label="产品型号" class="h-elformWrap-2">
                                <el-select v-model="f.productModel" placeholder="--请选择产品型号--" @change="selectCode(f)"
                                           class="h-tableInput"
                                           filterable>
                                    <el-option v-for="(item,index) in pModel" :key="index" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="产品编码" class="h-elformWrap-2">
                                <el-select v-model="f.productCode" placeholder="--请选择产品编码--" @change="selectModel(f)"
                                           class="h-tableInput"
                                           :filter-method="dataFilter"
                                           filterable>
                                    <el-option v-for="(item,index) in pCode" :key="index" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancer">取 消</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="decide">确定</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService';
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel';
    import wxxiangqingUpdate from '../../../views/loud/yuce/wxxiangqing/wxxiangqingSubmit'

    export default {
        components: {
            uploaddownexcel,wxxiangqingUpdate
        },
        name: 'leftMenu',
        data() {
            return {
                gjCo: [],
                pModel: [],
                pCode: [],
                pCodecopy: [],
                teshugaizhi:[],
                describe: [
                    {
                        specificId: '1',
                        des: '更改电源线'
                    },
                    {
                        specificId: '2',
                        des: '更改铭牌'
                    },
                    {
                        specificId: '3',
                        des: '外箱加贴唛头等'
                    },
                    {
                        specificId: '4',
                        des: '更改说明书/售后手册/检测报告等'
                    },
                    {
                        specificId: '5',
                        des: '内销型号改外销'
                    },
                    {
                        specificId: '6',
                        des: '拆电池'
                    },
                    {
                        specificId: '7',
                        des: '冰排放水'
                    },
                    {
                        specificId: '8',
                        des: '更改外包装箱'
                    },
                    {
                        specificId: '9',
                        des: '增加USB'
                    },
                    {
                        specificId: '11',
                        des: '增加圆盘记录仪'
                    },
                    {
                        specificId: '0',
                        des: '目录外改制'
                    }
                ],
                items: {},
                item2: {},
                dialogFormVisible: false,
                f: {
                    productModel: '',
                    productCode: ''
                },
                tableData: [],
                xbd: '',
                // 限制收货时间不让选择今天以前的
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
            }
        },
        mounted() {

        },
        created() {
            if (this.$route.query.taskstatus && this.$route.query.taskstatus == 1) {
                // TODO 跳转去查看页面也需要新加一个页面  因为拿到的是详情表的id  不再是主表id了
                this.$router.push({
                    path: "/yuce/showXiangqing",
                    query: {
                        cid: this.$route.query.ywid
                    }
                })
            } else {
                this.xbd = this.$route.query.ywid;
                this.query();
                this.showCountry();
            }
        },
        methods: {
            dataFilter(val){
                val = val.replace(/\s*/g,"");
                this.productCode = val;
                if (val) { //val存在
                    this.pCode = this.pCodecopy.filter((item) => {
                        if (!!~item.indexOf(val) || !!~item.toUpperCase().indexOf(val.toUpperCase())) {
                            return true
                        }
                    })
                } else { //val为空时，还原数组
                    this.pCode = this.pCodecopy;
                }
            },
            cancer() {
                this.dialogFormVisible = false;
            },
            decide() {
                if (this.f.productModel != this.items.proModel && this.f.productCode != this.items.proCode) {
                    this.items.proModel = this.f.productModel;
                    this.items.proCode = this.f.productCode;
                    // this.items.describe = [];
                    this.items.specificReq = [];
                    this.items.uids = [];
                    this.items.useData = [];
                    this.items.specific = [];
                    this.items.specificReform = '';
                    this.items.reformPriceRmb = '';
                }
                this.dialogFormVisible = false;
                ss.waixiao.selectProType(this.items.proCode, 2).then(rd => {
                    this.items.protype = rd;
                })
                // this.selectDingzhi(this.items);
                this.selectStock(this.items);
            },
            selectStock(v) {
                var obj= {
                    proCode: v.proCode
                }
                ss.waixiao.selectStock(obj).then(rd => {
                    if (rd && rd.length > 0) {
                        for (var i = 0; i < rd.length; i++) {
                            v.uids.push({
                                code: rd[i].id,
                                name: rd[i].strDes,
                            });
                        }
                    }
                })
            },
            // selectDingzhi(v) {
            //     ss.OrderMainService.listDingzhi({
            //         matecode: v.proCode
            //     }).then(rd => {
            //         if (rd.length > 0) {
            //             for (var i = 0; i < rd.length; i++) {
            //                 v.describe.push({
            //                     des: rd[i].des,
            //                     specificId: rd[i].id
            //                 });
            //             }
            //         }
            //     })
            // },
            selectCode(v) {
                for (var key in this.items.prolist) {
                    if (v.productModel == key) {
                        v.productCode = this.items.prolist[key];
                    }
                }
            },
            selectModel(v) {
                for (var key in this.items.prolist) {
                    if (v.productCode == this.items.prolist[key]) {
                        v.productModel = key;
                    }
                }
            },
            clickmodel(v) {
                if (v.country && v.country != '') {
                    this.f.productModel = v.proModel;
                    this.f.productCode = v.proCode;
                    this.items = v;
                    if (v.codeOpt.length == 0 || v.modelOpt.length == 0) {
                        var guojia = '';
                        var guoj = this.$store.getters.dictlist("YLCountry_agent");
                        for (var i = 0; i < guoj.length; i++) {
                            if (guoj[i].name == v.country) {
                                guojia = guoj[i].code;
                            }
                        }
                        if (!guojia || guojia == '') {
                            guojia = v.country;
                        }
                        var m = {
                            country: guojia
                        }
                        ss.waixiao.showProduct(m).then(rd => {
                            v.prolist = rd;
                            for (var key in rd) {
                                v.modelOpt.push(key);
                                v.codeOpt.push(rd[key]);
                            }
                            this.pModel = v.modelOpt;
                            this.pCode = v.codeOpt;
                            this.pCodecopy = v.codeOpt;
                            this.dialogFormVisible = true;
                        })
                    } else {
                        this.pModel = v.modelOpt;
                        this.pCode = v.codeOpt;
                        this.pCodecopy = v.codeOpt;
                        this.dialogFormVisible = true;
                    }
                } else {
                    this.$msg.msge("请先选择国家！");
                }
            },
            clickCode(v) {
                if (v.country && v.country != '') {
                    this.f.productModel = v.proModel;
                    this.f.productCode = v.proCode;
                    this.items = v;
                    if (v.codeOpt.length == 0 || v.modelOpt.length == 0) {
                        var guojia = '';
                        var guoj = this.$store.getters.dictlist("YLCountry_agent");
                        for (var i = 0; i < guoj.length; i++) {
                            if (guoj[i].name == v.country) {
                                guojia = guoj[i].code;
                            }
                        }
                        if (!guojia || guojia == '') {
                            guojia = v.country;
                        }
                        var m = {
                            country: guojia
                        }
                        ss.waixiao.showProduct(m).then(rd => {
                            v.prolist = rd;
                            for (var key in rd) {
                                v.modelOpt.push(key);
                                v.codeOpt.push(rd[key]);
                            }
                            this.pModel = v.modelOpt;
                            this.pCode = v.codeOpt;
                            this.pCodecopy = v.codeOpt;
                            this.dialogFormVisible = true;
                        })
                    } else {
                        this.pModel = v.modelOpt;
                        this.pCode = v.codeOpt;
                        this.pCodecopy = v.codeOpt;
                        this.dialogFormVisible = true;
                    }
                } else {
                    this.$msg.msge("请先选择国家！");
                }
            },
            changeCountry(v) {
                v.proModel = '';
                v.proCode = '';
                v.protype = '';
                v.proNumber = '';
                v.useId = '';
                v.useMeg = '';
                v.isSpecific = '';
                v.specificReform = '';
                v.specificReq = '';
                v.specific = '';
                v.reformPriceRmb = '';
                v.specificType = '1';
                v.useData = [];
                v.uids = [];
                v.prolist = [];
                v.modelOpt = [];
                v.codeOpt = [];
                v.remark = '';
                v.deliveryDate = '';
            },
            changes(v) {
                if (v.isSpecific == 1) {
                    v.specific = '';
                    v.specificReq = '';
                    v.specificId = '';
                    v.specificType = '1';
                    v.specificReform = '';
                    v.reformPriceRmb = '';
                }
            },
            addspecificId(v) {
                v.specificId = '';
                v.reformPriceRmb = '';
                for (var i = 0; i < v.specific.length; i++) {
                    for (var j = 0; j < this.describe.length; j++) {
                        if (v.specific[i] == this.describe[j].des) {
                            if (this.describe[j].specificId && this.describe[j].specificId != '') {
                                if (v.specificId != null && v.specificId != '') {
                                    v.specificId = v.specificId + this.describe[j].specificId + ", "
                                } else {
                                    v.specificId = this.describe[j].specificId + ", "
                                }
                            }
                            if (this.describe[j].specificId == '9') {
                                if (v.reformPriceRmb != null && v.reformPriceRmb != '') {
                                    v.reformPriceRmb = v.reformPriceRmb + 335;
                                } else {
                                    v.reformPriceRmb = 335;
                                }
                            } else if (this.describe[j].specificId == '11') {
                                if (v.reformPriceRmb != null && v.reformPriceRmb != '') {
                                    v.reformPriceRmb = v.reformPriceRmb + 2010;
                                } else {
                                    v.reformPriceRmb = 2010;
                                }
                            } else {
                                if (v.reformPriceRmb != null && v.reformPriceRmb != '') {
                                    v.reformPriceRmb = v.reformPriceRmb + 0;
                                } else {
                                    v.reformPriceRmb = 0;
                                }
                            }
                        }
                    }
                }
                var index = v.specificId.indexOf("0");
                console.log(index)
                if(index == -1){
                    v.flag = true;
                    v.specificType = '1';
                }else{
                    v.flag = false;
                    v.specificType = '2';
                }
            },
            addUseId(v) {
                v.useId = '';
                if (v.useData && v.useData.length != 0 && v.uids && v.uids.length != 0) {
                    for (var i = 0; i < v.useData.length; i++) {
                        for (var j = 0; j < v.uids.length; j++) {
                            if (v.useData[i] == v.uids[j].name) {
                                if (v.useId != null && v.useId != '') {
                                    v.useId = v.useId + v.uids[j].code + ","
                                } else {
                                    v.useId = v.uids[j].code + ","
                                }
                            }
                        }
                    }
                }
            },
            query() {
                var obj= {
                    id: this.xbd
                }
                ss.waixiao.showRevise(obj).then(rd => {
                    for (var i = 0; i < rd.length; i++) {
                        if (!rd[i].specificReform) {
                            rd[i]['specificReform'] = '';
                        }
                        // rd[i]['describe'] = [];
                        rd[i]['specific'] = '';
                        rd[i]['useData'] = [];
                        // rd[i]['reform'] = [];
                        rd[i]['uids'] = [];
                        rd[i]['flag'] = true;
                    }
                    this.tableData = rd;
                    var country = this.$store.getters.dictlist("YLCountry_agent");
                    for (var i = 0; i < this.tableData.length; i++) {
                        this.tableData[i].modelOpt = [];
                        this.tableData[i].codeOpt = [];
                        this.tableData[i].prolist = [];
                        for (var j = 0; j < country.length; j++) {
                            if (this.tableData[i].country == country[j].code) {
                                this.tableData[i].country = country[j].name
                            }
                        }
                        if (this.tableData[i].specificReq != '') {
                            //循环设置
                            if(this.tableData[i].specificReq.toString() == "0"){
                                this.tableData[i].specific = _.split(this.tableData[i].specificReq || [], ",");
                            }
                        }
                        if (this.tableData[i].useMeg && this.tableData[i].useMeg != '') {
                            //循环设置
                            this.tableData[i].useData = _.split(this.tableData[i].useMeg || [], ",");
                        }
                        // if (this.tableData[i].specificReform && this.tableData[i].specificReform != '') {
                        //     //循环设置
                        //     this.tableData[i].reform = _.split(this.tableData[i].specificReform || [], ",");
                        // }
                        //页面打开加载预测库存列表
                        this.selectStock(this.tableData[i]);
                    }
                })
            },
            showCountry() {
                var country = this.$store.getters.dictlist("YLCountry_agent");
                ss.waixiao.selectCountry().then(rd => {
                    for (var i = 0; i < rd.length; i++) {
                        for (var j = 0; j < country.length; j++) {
                            if (country[j].code == rd[i]) {
                                this.gjCo.push(country[j].name);
                            }
                        }
                    }
                })
            },
            subTo() {
                this.$msg.confirm("确认提交?", () => {
                    if (this.tableData.length == 0) {
                        this.$msg.msge("数据不能为空,请填写数据!");
                    } else {
                        var f = true;
                        b:
                            for (var s = 0; s < this.tableData.length; s++) {
                                for (var c in this.tableData[s]) {
                                    if (c == 'specific') {
                                        if (this.tableData[s][c] == "" && c == 'specific' && this.tableData[s].isSpecific == 2) {
                                            // this.$msg.msge("您填写的产品中有定制的产品且未输入定制需求!");
                                            // f = false;
                                            // break b;
                                        }
                                    } else {
                                        if (this.tableData[s][c] == '' && c == 'specificReform' && this.tableData[s].flag == false) {
                                            this.$msg.msge("您提交的数据中有改制要求未填写!");
                                            f = false;
                                            break b;
                                        }
                                        if (this.tableData[s][c] == "" && c == 'protype') {
                                            this.$msg.msge("您提交的数据中有型号属性为空的数据, 请仔细确认!");
                                            f = false;
                                            break b;
                                        }
                                        if (this.tableData[s][c] == "" && (c == 'country' || c == 'proModel' || c == 'proCode'
                                            || c == 'proNumber' || c == 'isSpecific' || c == 'deliveryDate')) {
                                            console.log(c, "这个未填!")
                                            this.$msg.msge("您的数据有未填项,请填写数据!");
                                            f = false;
                                            break b;
                                        }
                                        // if (this.tableData[s][c] == "" && c != 'specificType' && c != 'passDate' && c != 'useId' && c != 'useMeg'
                                        //     && c != 'useData' && c != 'uids' && c != 'specific' && c != 'specificReq'
                                        //     && c != 'useInventory' && c != 'productId' && c != 'lockStatus' && c != 'useNumber'
                                        //     && c != 'remark' && c != 'specificId' && c != 'describe' && c != 'modelOpt'
                                        //     && c != 'codeOpt' && c != 'prolist' && c != 'protype') {
                                        //     console.log(c, "这个未填!")
                                        //     this.$msg.msge("您的数据有未填项,请填写数据!");
                                        //     f = false;
                                        //     break b;
                                        // }
                                    }
                                }
                            }
                        if (f) {
                            var cou = this.$store.getters.dictlist("YLCountry_agent");
                            for (var i = 0; i < this.tableData.length; i++) {
                                for (var j = 0; j < cou.length; j++) {
                                    if (cou[j].name == this.tableData[i].country) {
                                        this.tableData[i].country = cou[j].code
                                    }
                                }
                                if (this.tableData[i].isSpecific == 2) {
                                    //循环设置
                                    this.tableData[i].specificReq = _.join(this.tableData[i].specific || [], ",");
                                } else {
                                    this.tableData[i].specificId = '';
                                    this.tableData[i].specificReq = '';
                                }

                                if (this.tableData[i].useData && this.tableData[i].useData != '') {
                                    this.tableData[i].useMeg = _.join(this.tableData[i].useData || [], ",");
                                } else {
                                    this.tableData[i].useId = '';
                                    this.tableData[i].useMeg = '';
                                }

                                // if (this.tableData[i].reform && this.tableData[i].reform != '') {
                                //     this.tableData[i].specificReform = _.join(this.tableData[i].reform || [], ",");
                                // } else {
                                //     this.tableData[i].specificReform = '';
                                // }

                                // this.tableData[i].describe = [];
                                this.tableData[i].prolist = [];
                                this.tableData[i].modelOpt = [];
                                this.tableData[i].codeOpt = [];

                                if (!this.tableData[i].specificType || this.tableData[i].specificType == '') {
                                    if (this.tableData[i].isSpecific == 1) {
                                        this.tableData[i].specificType = '1';
                                    } else {
                                        var index = this.tableData[i].specificId.indexOf("0");
                                        console.log(index)
                                        if(index == -1){
                                            this.tableData[i].specificType = '1';
                                        }else{
                                            this.tableData[i].specificType = '2';
                                        }
                                    }
                                }
                                console.log(this.tableData[i].specificType,"????");
                            }
                            //// ss.waixiao.subTo(this.tableData).then(rd => {
                            //// 新版提交
                            ss.waixiao.subRevise(this.tableData).then(rd => {
                                this.$msg.msgs(rd.msg);
                                this.$router.push({
                                    path: "/yuce/wxxiangqing"
                                });
                            });
                        }
                    }
                })
            },
            updateOpen(data){
                let self = this;
                self.$refs["mychild1"].isShowDia(data,true);
                self.saveData = data;
            },
            // deleteRow(index, rows) {
            //     this.$msg.confirm("确认删除?", () => {
            //         rows.splice(index, 1);
            //     })
            // },
            renovate() {
                this.$router.push({
                    path: "/yuce/wxxiangqing"
                });
            }
        }
    }
</script>
<style>
    .iconss .h-tableInput .el-input__inner {
        padding: 0.05rem 0.1rem;
    }
	
	.iconss .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}

    .iconss .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
        width: 90%;
    }

    .yhbrselect .el-input__inner {
        height: 0.6rem;
        border: 0;
        color: #2785e7;
        font-size: 0.18rem;
        background: 0;
    }

    .yhbrselect .el-input__inner:focus {
        border: 1px solid #2785e7;
        box-shadow: 0 0 0.16rem rgba(39, 133, 231, 0.35) inset;
    }

    .h-formBorder.ljjclassforms .el-input__inner {
        border: 0;
        border-bottom: 1px solid #d1d1d1;
    }

    .ljjclasstans .el-dialog__footer {
        text-align: center;
    }
</style>
